// extracted by mini-css-extract-plugin
module.exports = {"cls1":"FieldSet-CssProp1_fieldset-module--cls1--8F5YJ","cls2":"FieldSet-CssProp1_fieldset-module--cls2--672HG FieldSet-CssProp1_fieldset-module--cls1--8F5YJ"};